import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockTransferReportModel} from "./stock-transfer-report.model";

@Component({
    selector: "wbo-stock-transfer-report",
    templateUrl: "./stock-transfer-report.component.html",
    providers: [provideReportModel(StockTransferReportModel)]
})
export class StockTransferReportComponent extends AbstractReportPage {
    constructor(public model: StockTransferReportModel) {
        super();
    }
}
